import type { NullableString } from '@shared_types/global_types'
import { isNil, isNull, isString, isUndefined } from 'lodash'

const falsyStrings = new Set(['null', 'undefined'])

export const DEGREE_SYMBOL = '\xBA'

export function nl2br (str: string, isXhtml?: boolean) {
  if (isUndefined(str) || isNull(str) || !isString(str)) {
    return ''
  }

  const breakTag = isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>'
  return `${str}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}

export function isFalsyString (str: string) {
  return falsyStrings.has(str.trim().toLowerCase())
}

export function sanitizeString (str?: NullableString, fallback = '') {
  const isFalsy = isNil(str) || (isString(str) && isFalsyString(str))
  return isFalsy ? fallback : str
}
